const plasticRoles = {
  Chief: 'Chief',
  Admin: 'Admin',
  Viewer: 'Viewer',
  QualityControl: 'QualityControl',
  PlasticChief: 'PlasticChief',
  PlasticEngineer: 'PlasticEngineer',
  PlasticInspectionMachine: 'PlasticInspectionMachine',
  PlasticInspectionTrimming: 'PlasticInspectionTrimming',
  PlasticLeaderMachine: 'PlasticLeaderMachine',
  PlasticLeaderTrimming: 'PlasticLeaderTrimming',
  PlasticViewer: 'PlasticViewer',
  PlasticQc: 'PlasticQC',
  WorkShopMoldUser: 'WorkShopMoldUser',
  WorkShopMoldViewer: 'WorkShopMoldViewer',
  PlasticScrapDataImage: 'PlasticScrapDataImage',
};

const accesToAllViews = [
  plasticRoles.Admin,
  plasticRoles.Chief,
  plasticRoles.PlasticChief,
  plasticRoles.Viewer,
  plasticRoles.PlasticViewer,
];
const allViewDepartment = [
  plasticRoles.PlasticEngineer,
  plasticRoles.PlasticInspectionMachine,
  plasticRoles.PlasticInspectionTrimming,
  plasticRoles.PlasticLeaderMachine,
  plasticRoles.PlasticLeaderTrimming,
];

const accesToAllActions = [
  plasticRoles.Admin,
  plasticRoles.Chief,
  plasticRoles.PlasticChief,
];
const allActionsDepartment = [
  plasticRoles.PlasticEngineer,
  plasticRoles.PlasticInspectionMachine,
  plasticRoles.PlasticInspectionTrimming,
  plasticRoles.PlasticLeaderMachine,
  plasticRoles.PlasticLeaderTrimming,
  plasticRoles.Viewer,
  plasticRoles.PlasticViewer,
];

export const plasticViewRoles = {
  verDepartment: [
    plasticRoles.QualityControl,
    plasticRoles.PlasticQc,
    plasticRoles.PlasticScrapDataImage,
    ...accesToAllViews,
    ...allViewDepartment,
  ],
  verMaquinas: [...accesToAllViews, ...allViewDepartment],
  verMoldes: [
    ...accesToAllViews,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticInspectionMachine,
    plasticRoles.PlasticLeaderMachine,
    plasticRoles.PlasticLeaderTrimming,
    plasticRoles.QualityControl,
    plasticRoles.PlasticQc,
  ],
  verInspeccion: [
    ...accesToAllViews,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticInspectionMachine,
    plasticRoles.PlasticLeaderMachine,
    plasticRoles.PlasticLeaderTrimming,
    plasticRoles.QualityControl,
    plasticRoles.PlasticScrapDataImage,
  ],
  verValidacion: [
    ...accesToAllViews,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticInspectionMachine,
    plasticRoles.PlasticLeaderMachine,
  ],
  verPowerBI: [...accesToAllViews, ...allViewDepartment],
  verReparacion: [
    plasticRoles.Chief,
    plasticRoles.Admin,
    plasticRoles.WorkShopMoldUser,
    plasticRoles.WorkShopMoldViewer,
  ],
};

export const placticActionsRoles = {
  Cambiardeturno: [
    ...accesToAllActions,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticLeaderMachine,
  ],
  Saltarbrazo: [
    ...accesToAllActions,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticLeaderMachine,
  ],
  TiempoMuertoMaquina: [...accesToAllActions, plasticRoles.PlasticEngineer],
  TiempoMuertoBrazo: [...accesToAllActions, plasticRoles.PlasticEngineer],
  TiempoMuertoSinregistro: [...accesToAllActions],
  FinalizarCiclo: [
    ...accesToAllActions,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticLeaderMachine,
  ],
  MoverMoldes: [
    ...accesToAllActions,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticLeaderMachine,
  ],
  Verdetallesmoldes: [...accesToAllActions, ...allActionsDepartment],
  Verbom: [...accesToAllActions, ...allActionsDepartment],
  EditarMoldes: [...accesToAllActions, plasticRoles.PlasticEngineer],
  ActualizarMoldeImagen: [plasticRoles.QualityControl, plasticRoles.PlasticQc],
  CrearMoldes: [...accesToAllActions, plasticRoles.PlasticEngineer],
  InspeccionarSimple: [
    ...accesToAllActions,
    plasticRoles.PlasticInspectionMachine,
  ],
  InspeccionarDetallado: [
    ...accesToAllActions,
    plasticRoles.PlasticInspectionMachine,
  ],
  Enviarvalidacion: [
    ...accesToAllActions,
    plasticRoles.PlasticEngineer,
    plasticRoles.PlasticInspectionMachine,
    plasticRoles.PlasticLeaderMachine,
  ],
  manualInspection: [
    plasticRoles.PlasticEngineer,
    plasticRoles.Admin,
  ],
  // Rol que solo ve inspecciones, pero en el tab de Scrap se le pide validar un
  // número de empleado (auxiliar de plásticos) para poder inspeccionar.
  ScrapDataImage: [plasticRoles.PlasticScrapDataImage],
};
